module.exports = __webpack_public_path__ + "static/media/30OIOS11.618e73fa.jpg";